import React from "react";
import { Settings } from "lucide-react";
import { useIntl } from "react-intl";
import useChartClock from "./useChartClock";
import "./ChartClock.sass";

/**
 * Displays the current time in the profile time zone (updates every second)
 * and the gear that opens the time zone panel (TV-10).
 *
 * @param {object} props
 * @param {string} props.timezone - IANA timezone string
 * @param {boolean} props.isSettingsOpen - the time zone panel is open
 * @param {() => void} props.onOpenSettings
 * @param {boolean} [props.isInline] - on phones the clock stands beside the toolbar buttons
 */
const ChartClock = ({ timezone, isSettingsOpen, onOpenSettings, isInline = false }) => {
  const intl = useIntl();
  const timeString = useChartClock(timezone);

  const timezoneSettingsLabel = intl.formatMessage({
    id: "futures.chart.toolbar.timezone_settings",
  });

  return (
    <div className={`chart-clock${isInline ? " chart-clock--inline" : ""}`}>
      <span className="chart-clock__time">{timeString}</span>
      <button
        type="button"
        className={`chart-clock__settings${isSettingsOpen ? " chart-clock__settings--active" : ""}`}
        aria-label={timezoneSettingsLabel}
        title={timezoneSettingsLabel}
        aria-haspopup="dialog"
        aria-expanded={isSettingsOpen}
        onClick={onOpenSettings}
      >
        <Settings size={14} aria-hidden="true" />
      </button>
    </div>
  );
};

export default ChartClock;
